module.exports = __webpack_public_path__ + "img/jaoc_pizzagame_black-make.5cd0fbd2.png";